import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import { COLORS } from 'src/utils/Themes/colors'
import Modal from 'src/components/common/Modal'
import AllRenewals from 'src/components/RiskReports/UpComingRenewals/AllRenewals'
import { RISK_REPORTS } from 'src/utils/constants/RiskReports'
import formatDate from 'src/utils/commonMethods/formatDate'
import formatToINR from 'src/utils/commonMethods/formatToINR'

const UpcomingRenewals = ({ aggregatedPolicies, ClientId, insuranceName }) => {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const [cutoffRenewals, setCutoffRenewals] = useState([])

  const closeModal = () => {
    setModalOpen(false)
  }

  const handleViewAll = () => {
    setModalOpen(true)
  }

  const getCutOffRenewals = () => {
    const nearToExpirePolicies =
      aggregatedPolicies?.nearToExpirePolicies?.slice(0, 2)
    let policies = []
    if (nearToExpirePolicies?.length === 2) {
      policies = [
        ...nearToExpirePolicies?.[0]?.policies,
        ...nearToExpirePolicies?.[1]?.policies,
      ]
    } else if (nearToExpirePolicies?.length === 1) {
      policies = [...nearToExpirePolicies?.[0]?.policies]
    }
    setCutoffRenewals(policies?.slice(0, 2))
  }

  useEffect(() => {
    if (Object.keys(aggregatedPolicies)?.length) {
      getCutOffRenewals()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aggregatedPolicies])

  return (
    <>
      <div className={classes.upcomingRenewalsWrapper}>
        {modalOpen ? (
          <Modal
            bgcolor={COLORS?.WHITE}
            class={classes.modalRoot}
            ordered={modalOpen}
            width={'90%'}
            left={'5%'}
            top={'5%'}
            modelClosed={closeModal}
          >
            <div className={classes.modalContent}>
              <AllRenewals
                aggregatedPolicies={aggregatedPolicies}
                closeModal={closeModal}
                ClientId={ClientId}
                insuranceName={insuranceName}
              />
            </div>
          </Modal>
        ) : null}
        <Card classes={{ root: classes.root }}>
          <CardContent classes={{ root: classes.contentRoot }}>
            <div className={classes.renewalsItemWrapper}>
              <div className={classes.legend}>
                <span className={classes.legendTitle}>
                  {RISK_REPORTS?.UPCOMING_RENEWALS}
                </span>
                <span
                  id='viewAll'
                  aria-hidden='true'
                  onClick={handleViewAll}
                  className={classes.viewAll}
                >
                  {RISK_REPORTS?.VIEW_ALL}
                </span>
              </div>
              <div className={classes.renewalsContent}>
                {cutoffRenewals?.length ? (
                  <>
                    {cutoffRenewals?.map((item, index) => {
                      const iconUrl = get(item, 'productImage', '')
                      const title = get(item, 'insuranceType', '')
                      const expDate = get(item, 'expiresOn', '')
                      const premiumPaid = get(item, 'premiumAmount.text', 0)

                      return (
                        <div
                          key={`renewals-${index}`}
                          className={classes.renewalsItem}
                        >
                          <div className={classes.renewalIconContainer}>
                            <img
                              src={iconUrl}
                              alt='title'
                              className={classes.icon}
                            />
                            <div className={classes.title}>{title}</div>
                          </div>

                          <div className={classes.renewalDetailsContainer}>
                            <div className={classes.expDate}>
                              {RISK_REPORTS?.EXPIRED}:&nbsp;
                              {expDate
                                ? formatDate(expDate, 'dd-mmm-yyyy')
                                : ''}
                            </div>
                            <div className={classes.premiumPaid}>
                              {RISK_REPORTS?.PREMIUM_PAID}
                              <div className={classes.amt}>
                                {formatToINR(premiumPaid)}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </>
                ) : (
                  <div className={classes.noDataText}>
                    There are no policies that are near to expire
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default UpcomingRenewals

const useStyles = makeStyles({
  upcomingRenewalsWrapper: {
    marginTop: '0px',
  },
  root: {
    borderRadius: '10px',
  },
  renewalsItemWrapper: {
    display: 'flex',
    overflow: 'hidden',
  },
  contentRoot: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  legend: {
    maxWidth: '140px',
    flexBasis: '150px',
    background: COLORS.DARK_PINK,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    '@media (max-width:1400px)': {
      flexDirection: 'column',
      gap: '5px',
    },
  },

  legendTitle: {
    fontSize: '20px',
    lineHeight: '24px',
    color: COLORS.WHITE,
    fontWeight: 600,
    marginBottom: '20px',
    textAlign: 'center',
  },
  viewAll: {
    textDecoration: 'underline',
    fontSize: '13px',
    color: COLORS.LINK_COLOR_LIGHT,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
  renewalsContent: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  renewalsItem: {
    borderBottom: `0.7px solid ${COLORS.GREY_11}`,
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    width: '95%',
    '&:last-child': {
      borderBottom: '0px solid',
    },
    '@media (max-width:1400px)': {
      flexDirection: 'column',
      gap: '5px',
    },
  },
  icon: {
    width: '30px',
    height: '30px',
    marginRight: '10px',
  },
  renewalIconContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  renewalDetailsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '@media (max-width:800px)': {
      flexDirection: 'column',
      gap: '5px',
      alignItems: 'flex-start',
    },
  },
  title: {
    fontSize: '14px',
    lineHeight: '18px',
    color: COLORS.GREY,
    // flexBasis: "145px",
    fontWeight: '600',
  },
  expDate: {
    fontSize: '13px',
    color: COLORS.GREY_10,
  },
  premiumPaid: {
    fontSize: '11px',
    color: COLORS.GREY_10,
  },
  amt: {
    color: COLORS.GREY,
    fontSize: '16px',
    marginTop: '0px',
    fontWeight: '500',
    // textAlign: "center",
    textAlign: 'initial',
  },
  modalRoot: {
    height: '90%',
    overflow: 'auto',
  },
  modalContent: {
    textAlign: 'center',
    padding: '0px 24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
    margin: '24px 0px',
    boxSizing: 'border-box',
  },
  noDataText: {
    textAlign: 'center',
    fontWeight: 'bold',
    opacity: '0.3',
    marginBottom: '10px',
  },
})
